'use client'
import React from "react";

const Feedback = () => {
    return (
        <div className="cursor-pointer p-8 font-medium text-sm text-gray-900 hover:text-gray-400">
            <a
                href="https://forms.office.com/r/DMY2nSTmkZ"
                target="_blank"
                rel="noreferrer"
            >
                FEEDBACK
            </a>
        </div>
    );
};

export default Feedback;
